import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Box, Grid } from '@mui/material'
import {
  LayoutProps,
  getStaticProps as getLayoutStaticProps,
} from '../components/Layout'
import sanity from '../lib/sanity'
import MapOverview from '../components/util/MapOverview'
import { BoxOverview } from '../components/shared/BoxOverview'
import { HeaderMedium } from '../components/shared/HeaderMedium'
import { Header } from '../components/shared/Header'

const Index = () => {
  const columnsBox: { title: string; number: number; numberCaption: number }[] =
    [
      {
        title: 'Total no. of falls monitoring',
        number: 4,
        numberCaption: 2,
      },
      { title: 'Total no. of falls', number: 53, numberCaption: 7 },
      {
        title: 'Total no. of falls in the last 24 hrs',
        number: 12,
        numberCaption: 5,
      },
    ]
  return (
    <>
      <Header textHeader="Dashboard" />
      <Grid
        container
        spacing={2}
        sx={{
          backgroundColor: 'common.white',
          display: 'flex',
          padding: '30px 0',
        }}
      >
        <Grid item xs={8}>
          <MapOverview />
        </Grid>
        <Grid item xs={4}>
          <HeaderMedium textHeader="Overview" />
          <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
            {Object.keys(columnsBox).map((key, i) => (
              <BoxOverview
                key={key}
                textBox={columnsBox[i].title}
                numberBox={columnsBox[i].number}
                numberCaptionBox={columnsBox[i].numberCaption}
              />
            ))}
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

interface Props extends LayoutProps {
  example_image: string
}

export const getStaticProps = async (): Promise<{ props: Props }> => ({
  props: {
    ...(await sanity.fetch(
      `*[_type == 'settings' && _id == 'settings'][0] {
        "example_image": example_image.asset._ref
      }`,
    )),
    ...(await getLayoutStaticProps()).props,
  },
})

export default withAuthenticationRequired(Index)
